import { Instance, SnapshotOut, types } from "mobx-state-tree";
import { CommonCode } from "../common-code/CommonCode";

/**
 * # Cutoff
 * 
 * Cutoff을 설명하세요.
 */

export const Color = types.model('Color', {
  code: types.maybeNull(types.optional(types.string, "")),
  pcode: types.maybeNull(types.optional(types.string, "")),
  value: types.maybeNull(types.optional(types.string, "")),
  enumValue: types.maybeNull(types.optional(types.string, "")),
});
type TColor = Instance<typeof Color>;
export interface IColor extends TColor {}
export const createColor = () => 
  types.optional(Color, {} as TColor);

export const Cutoff = types
  .model("Cutoff")
  // --------------------------------------------------------------------------
  .props({
    cutoffSid : types.maybeNull(types.optional(types.number, 0)),
    cdssTypeCd: types.maybeNull(types.optional(CommonCode, {})),
    min : types.maybeNull(types.optional(types.number, 0)),
    max : types.maybeNull(types.optional(types.number, 0)),
    color : types.maybeNull(types.optional(Color, {})),
    regId : types.maybeNull(types.optional(types.number, 0)),
    regDt : types.maybeNull(types.optional(types.string, "")),
    updId : types.maybeNull(types.optional(types.number, 0)),
    updDt : types.maybeNull(types.optional(types.string, "")),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model cutoff --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as ICutoff;
      (Object.keys(newProps) as TCutoffKeys[]).forEach((key) => {
        //@ts-ignore
        self[key] = newProps[key];
        
      });
    },
  }));

// --------------------------------------------------------------------------
type TCutoff = Instance<typeof Cutoff>;
type TCutoffSnapshot = SnapshotOut<typeof Cutoff>

export interface ICutoff extends TCutoff {}
export type TCutoffKeys = keyof TCutoffSnapshot & string;
export interface ICutoffSnapshot extends TCutoffSnapshot {}
export const createCutoff = () => 
  types.optional(Cutoff, {
} as TCutoff);
